module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/flatten-68365b292f47dd34be14763b4f17172f.svg";